export default __webpack_public_path__ + "d671c5e023bf370432c4c88aa44ce13d.png";